import "@/styles/index.css";
import 'lazysizes';

import { initToTheTop } from './components/toTheTop';
import { initMenuToggle } from './components/menuToggle';
import { initHomeCarousel } from './components/homeCarousel';
import { initEntryCarousel } from './components/entryCarousel';
import { initFadeInOnScroll } from './components/fadeInOnScroll';
import { initTheme } from './components/theme';
import { initScrollTheme } from './components/scrollTheme';
import { initHeaderScroll } from './components/headerScroll';

document.addEventListener('DOMContentLoaded', () => {
  initTheme();
  initToTheTop();
  initMenuToggle();
  initHomeCarousel();
  initEntryCarousel();
  initHeaderScroll();

  const scrollTheme = initScrollTheme({
    threshold: 0.2,             // More sensitive threshold
    rootMargin: '-5% 0px -5% 0px',  // Reduced margin for earlier detection
    debug: false                // Set to true for troubleshooting
  });
  
  // Expose scrollTheme to window for debugging
  window.scrollTheme = scrollTheme;
  
  // Helper function for debugging theme switching
  window.debugTheme = (enable = true) => {
    scrollTheme.setDebug(enable);
    console.log(`Theme debugging ${enable ? 'enabled' : 'disabled'}`);
    return 'Type window.debugTheme(false) to disable debugging';
  };

  const fadeInScroll = initFadeInOnScroll({
    threshold: 0.2,
    once: true
  });
  
  window.fadeInScroll = fadeInScroll;
});

console.log("%c Developed by ANTI - https://anti.as/", "background: #000; color: #fff;");